module.exports = __webpack_public_path__ + "static/img/logo.5265a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo.png
// module id = vVZ4
// module chunks = 15